import React, {useEffect, useState, useRef, ChangeEvent} from "react";
import {
  ITrialScheduleResponse,
  ITrial,
  ITrialRegistrationRequest,
  ITrialRegistrationResponse,
  ITrialRegistration,
  ITrialGroup,
} from "./types";
import {getTrialSchedule, registerForTrial} from "./Api";
// import { Loading } from "./Loading";
import "./TrialSchedulePage.css";

interface BannerProps {}
export const Banner = (props: BannerProps) => {
  return (
    <div className="banner-container">
      <img src="/banner.jpg" className="banner" alt="" />
    </div>
  );
};

interface InfoProps {}
export const Info = (props: InfoProps) => {
  return (
    <div className="column">
      <div className="info-container">
        <h2>KMS Tae Kwon Do Schnupper Programm</h2>

        <p> Sie wissen noch nicht, ob Kampfkunst das Richtige für Sie ist? Kein
          Problem! - Bei KMS-Taekwondo haben Sie die Möglichkeit <span
            className="bold-text">3x&nbsp;Gruppentraining</span> für nur <span
              className="bold-text">20&nbsp;Euro</span> auszuprobieren. Sie können aus den
          angeführten Zeiten selbst auswählen. Beim ersten Besuch erklären wir
          Ihnen dann genau, wie unsere Schule aufgebaut ist und wie man bei uns
          Taekwondo lernt.  </p>

        <p>
          Nicht vergessen, Sportbekleidung mitzunehmen. Sind Sie noch jünger,
          sollten Sie am besten in Begleitung der Eltern vorbeikommen.
        </p>

        <p className="bold-text">
          Für eine Anmeldung zum Probetraining bitte das unten stehende Formular
          ausfüllen, sobald als möglich bekommen sie per Email eine Rückmeldung.
        </p>
      </div>
    </div>
  );
};

interface RegistrationProps {
  trial: ITrial | null;
  submit: (reg: ITrialRegistrationRequest) => void;
}
const Registration = (props: RegistrationProps) => {
  const {trial, submit} = props;
  const [isSubmitable, setIsSubmitable] = useState<Boolean>(false);
  const nameRef = useRef<HTMLInputElement>(null);
  const phoneRef = useRef<HTMLInputElement>(null);
  const emailRef = useRef<HTMLInputElement>(null);
  const ageRef = useRef<HTMLInputElement>(null);
  const onInputChanged = () => {
    if (nameRef.current === null || nameRef.current.value === "") {
      setIsSubmitable(false);
      return;
    }
    if (phoneRef.current === null || phoneRef.current.value === "") {
      setIsSubmitable(false);
      return;
    }
    if (emailRef.current === null || emailRef.current.value === "") {
      setIsSubmitable(false);
      return;
    }
    if (ageRef.current === null || ageRef.current.value === "") {
      setIsSubmitable(false);
      return;
    }
    setIsSubmitable(true);


  };
  const confirm = () => {
    console.log(`trial id: ${trial?.id}`);
    const reg: ITrialRegistrationRequest = {
      phone: phoneRef.current?.value || "",
      email: emailRef.current?.value || "",
      name: nameRef.current?.value || "",
      trial_id: trial?.id ?? -1,
      created_at: new Date().toJSON(),
      age: ageRef.current?.value || "",
    };
    submit(reg);
  };

  const isValid = isSubmitable && trial !== null;
  return (
    <div className="column">
      <input onChange={onInputChanged} ref={nameRef} placeholder="Name" required />
      <input onChange={onInputChanged} ref={ageRef} placeholder="Alter" required />
      <input onChange={onInputChanged} ref={phoneRef} placeholder="Telefon" type="phone" required />
      <input onChange={onInputChanged} ref={emailRef} placeholder="Email" type="email" required />
      <button onClick={confirm} disabled={!isValid}>Bestätigen</button>
      <input type="submit" hidden onSubmit={confirm} disabled={!isValid} />
    </div>
  );
};

interface ITrialGroupProps {
  trial_groups: ITrialGroup[];
  select_trial_group: (trial_group: ITrialGroup) => void;
}
const TrialGroup = (props: ITrialGroupProps) => {
  const {trial_groups, select_trial_group} = props;
  const onIdSelected = (ev: ChangeEvent<HTMLSelectElement>) => {
    let tg = trial_groups.find(t => t.id === parseInt(ev.currentTarget.value));
    if (tg !== undefined) {
      select_trial_group(tg)
    }
    else {
      console.error('selected id', ev.currentTarget.value, 'but could not find trial group');
    }
  };

  const selectComp = <select name="group_select" onChange={onIdSelected} required>
    <option hidden disabled selected> -- Bitte Gruppe wählen -- </option>
    {
      trial_groups.map((tg: ITrialGroup) => {
        return <option value={tg.id} >{tg.name}</option>;
      })
    }
  </select>;
  return (
    <div>
      <label htmlFor="group_select">Altersgruppe auswählen</label>
      {selectComp}
    </div>
  );
}

interface ITrialProps {
  trialSchedule: ITrialScheduleResponse;
  selectedTrialGroup: ITrialGroup | null;
  selectTrial: (trial: ITrial) => void;
}
const Trial = (trialProps: ITrialProps) => {
  const {trialSchedule, selectedTrialGroup, selectTrial} = trialProps;
  console.log('trial: ', JSON.stringify(trialSchedule));

  // filter the trials for the selected group
  let filteredTrials: ITrial[] = [];
  if (selectedTrialGroup !== null) {
    filteredTrials = trialSchedule.trials
      .filter(((t: ITrial) => {
        console.log('filtering', t.trial_group_id, selectedTrialGroup.id);
        return t.trial_group_id === selectedTrialGroup.id;
      }));
  }


  const onTrialIdSelected = (ev: ChangeEvent<HTMLSelectElement>) => {
    let t = filteredTrials.find(t => t.id == parseInt(ev.currentTarget.value));
    if (t !== undefined) {
      selectTrial(t);
    }
    else {
      console.error('selected id', ev.currentTarget.value, 'but could not find trial');
    }
  };

  const fmter = new Intl.DateTimeFormat('at', {
    month: "short",
    day: "2-digit",
    weekday: "long",
    hour: "2-digit",
    minute: "2-digit",
  });

  // return the component drop-down compnent for selecting the group

  const selectComp = <select name="trial_select" onChange={onTrialIdSelected} required>
    <option hidden disabled selected> -- Bitte Termin wählen -- </option>
    {
      filteredTrials.map((t: ITrial) => {
        return <option value={t.id}>{fmter.format(new Date(t.datetime))}</option>;
      })}
  </select>;


  return <div>
    <label htmlFor="trial_select">Termin auswählen</label>
    {selectComp}
  </div>
};

interface IInputFieldsProps {}
const InputFields = (props: IInputFieldsProps) => {

}

interface IRegistrationFormProps {}
const RegistrationForm = (props: IRegistrationFormProps) => {
  const [
    trialSchedule,
    setTrialSchedule,
  ] = useState<ITrialScheduleResponse | null>(null);
  const [selectedTrialGroup, setSelectedTrialGroup] = useState<ITrialGroup | null>(null);
  const [selectedTrial, setSelectedTrial] = useState<ITrial | null>(null);
  const [registrationResponse, setRegistrationResponse] = useState<ITrialRegistrationResponse | null>();
  useEffect(() => {
    if (trialSchedule !== null) {
      console.log("skipping schedule request");
      return;
    }
    console.log("requesting");
    getTrialSchedule().then((newSchedule) => {
      console.log("response received", newSchedule);
      setTrialSchedule(newSchedule);
    });
  });
  if (trialSchedule === null) {
    return <div>loading...</div>;
  }
  const onSelectTrialGroup = (trialGroup: ITrialGroup) => {
    console.log('selecting trial group');
    setSelectedTrialGroup(trialGroup);
  };
  const onSelectTrial = (trial: ITrial) => {
    console.log('selecting trial:', JSON.stringify(trial));
    setSelectedTrial(trial);
  }
  const onSubmitRegistration = (trialRegistration: ITrialRegistration) => {
    registerForTrial(trialRegistration).then(
      (resp: ITrialRegistrationResponse) => {
        setRegistrationResponse(resp);
      }
    );
  };

  if (registrationResponse !== null && registrationResponse !== undefined) {
    let responseText = "Anmeldung bestätigt";
    if (registrationResponse.success !== true) {
      responseText = "Anmeldung fehlgeschlagen";
    }
    return <div ><h2>{responseText}</h2></div>;
  }
  return (
    <div>
      <TrialGroup trial_groups={trialSchedule.trial_groups} select_trial_group={onSelectTrialGroup} />
      <Trial trialSchedule={trialSchedule} selectedTrialGroup={selectedTrialGroup} selectTrial={onSelectTrial} />
      <Registration trial={selectedTrial} submit={onSubmitRegistration} />
    </div>
  );
};


interface IAppointmentProps {}
const Appointment = (props: IAppointmentProps) => {
  return <div />;
}

interface TrialSchedulePageProps {}

export const TrialSchedulePage = (props: TrialSchedulePageProps) => {
  return (
    <div className="root">
      <div className="container">
        <Banner />
        <Info />
        <RegistrationForm />
      </div>
    </div>
  );
};
